<template>
  <div id="app">
    <header>
      <el-button @click="previewShow=true">预览</el-button>
      <!-- <el-button @click="exportTemplate">导出</el-button> -->
    </header>
    <div class="demo-wrapper">
      <v-jdesign v-model="model" v-bind:profile="profile"></v-jdesign>
    </div>
    <el-dialog title="预览" v-bind:visible.sync="previewShow">
      <v-jform
        v-model="model"
        :fields="model.fields"
        :datasource="model.datasource"
        :listeners="model.listeners"
      ></v-jform>
    </el-dialog>
  </div>
</template>
<script>
import valuedata from "./value.json";
import profiledata from "./profile.json";
export default {
  data() {
    return {
      model: {},
      profile: {},
      previewShow: false
    };
  },
  methods: {},
  mounted() {
    console.log(valuedata);
    const config = valuedata;
    const profile = profiledata;
    this.model = config;
    this.profile = profile;
    console.log(this.model);
  }
};
</script>

<style>
#app {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.demo-wrapper {
  position: absolute;
  top: 50px;
  bottom: 0;
  left: 0;
  right: 0;
}

header {
  line-height: 49px;
  border-bottom: 1px solid silver;
  padding: 0 20px;
}
</style>
